import { RestClient } from '@/api/rest-client'
import { Credentials } from '@/api/model/credentials'

export class CredentialsClient extends RestClient<Credentials> {
    collectionName = 'credentials'
    parseData = Credentials.fromData
}
